var PageService = function() {
  this.saveProgress = function(blockView) {
    EF.module.progress.save(blockView.model);
  };
};

module.exports = new PageService();